"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _react = _interopRequireWildcard(require("react"));

var _url = require("ui-addon-upgrades/_core/common/navigation/url");

var _upgradeDataPropsInterface = require("ui-addon-upgrades/_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface");

var _getUpgradeLink = require("ui-addon-upgrades/_core/common/adapters/getUpgradeLink");

var _UpgradeModal = _interopRequireDefault(require("ui-addon-upgrades/decorators/UpgradeModal"));

var tracker = _interopRequireWildcard(require("ui-addon-upgrades/_core/common/eventTracking/tracker"));

var _getUpgradeButtonText = require("ui-addon-upgrades/_core/common/adapters/getUpgradeButtonText");

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _BannerSubtext = _interopRequireDefault(require("../common/components/BannerSubtext"));

var LockedFeatureMessage =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(LockedFeatureMessage, _React$Component);

  function LockedFeatureMessage() {
    var _this;

    (0, _classCallCheck2.default)(this, LockedFeatureMessage);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(LockedFeatureMessage).call(this));
    _this.handleLinkClick = _this.handleLinkClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(LockedFeatureMessage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var upgradeData = this.props.upgradeData;
      tracker.track('lockedFeatureBannerInteraction', (0, _extends2.default)({
        action: 'viewed'
      }, upgradeData));
    }
  }, {
    key: "handleLinkClick",
    value: function handleLinkClick() {
      var upgradeData = this.props.upgradeData;
      var upgradeLink = (0, _getUpgradeLink.getUpgradeLink)(upgradeData);
      tracker.track('lockedFeatureBannerInteraction', (0, _extends2.default)({
        action: 'clicked learn more'
      }, upgradeData));
      (0, _url.openNewTab)(upgradeLink);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          linkUse = _this$props.linkUse,
          upgradeData = _this$props.upgradeData,
          modalKey = _this$props.modalKey;
      return _react.default.createElement("span", null, _react.default.createElement("div", {
        className: "private-upgrades-message"
      }, _react.default.createElement(_BannerSubtext.default, {
        subText: _react.default.createElement(_FormattedMessage.default, {
          message: "upgrades.lockedFeatureBanner.text"
        }),
        linkUse: linkUse,
        upgradeProduct: upgradeData.upgradeProduct,
        onLinkClick: this.handleLinkClick
      }), _react.default.createElement(_UpgradeModal.default, {
        modalKey: modalKey,
        upgradeData: upgradeData
      }, function (_ref) {
        var openUpgradeModal = _ref.openUpgradeModal,
            preloadUpgradeModal = _ref.preloadUpgradeModal;
        return _react.default.createElement("div", {
          onClick: openUpgradeModal,
          onMouseOver: preloadUpgradeModal
        }, _react.default.createElement(_UIButton.default, {
          className: "private-upgrades-message-button",
          size: "small",
          use: "primary-white"
        }, (0, _getUpgradeButtonText.getUpgradeButtonText)('default', upgradeData.upgradeProduct)));
      })));
    }
  }]);
  return LockedFeatureMessage;
}(_react.default.Component);

LockedFeatureMessage.defaultProps = {
  linkUse: 'link',
  allowModal: true
};
LockedFeatureMessage.propTypes = (0, _extends2.default)({
  modalKey: _react.PropTypes.string.isRequired
}, _upgradeDataPropsInterface.upgradeDataPropsInterface);
var _default = LockedFeatureMessage;
exports.default = _default;
module.exports = exports.default;